import { DateTime } from "luxon"

import { getKPIValues } from "@/features/kpis/api/getKPIValues.ts"

import type { GasChartDataPoint } from "../../types/gasChartTypes.ts"

export const getGasChartData = async (): Promise<GasChartDataPoint[]> => {
  const values = await Promise.all([
    getKPIValues(80, { typeId: 1, locationId: 2, returnSize: 30 }),
    getKPIValues(50, { typeId: 1, locationId: 2, returnSize: 30 }),
    getKPIValues(55, { typeId: 1, locationId: 2, returnSize: 30 }),
  ])

  if (values[0].values == undefined) return []

  const gasChartData = values[0].values.map((val, i) => {
    const date = DateTime.fromISO(val.date).toFormat("L/d")
    const biogasFlared = values[1].values ? values[1].values[i]?.value || 0 : 0
    const biomethaneFlared = values[2].values ? values[2].values[i]?.value || 0 : 0

    return {
      date,
      gas: val.value,
      flared: biogasFlared * 0.6 + biomethaneFlared,
    }
  })

  return gasChartData.reverse()
}
